import { useContext, useEffect } from 'react';
import { GuardProps } from 'types';
import { useKeycloak } from 'keycloak-react-web';
import { ProfileContext } from 'contexts/ProfileContext';
import BlockedUser from 'views/blockedUser/BlockedUser';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { keycloak, initialized } = useKeycloak();
    const { blocked, profileIsReady } = useContext(ProfileContext);

    useEffect(() => {
        if (initialized) {
            if (!keycloak.authenticated) {
                keycloak.login();
            }
        }
    }, [initialized, keycloak]);

    return profileIsReady && keycloak.authenticated ? blocked ? <BlockedUser /> : children : <></>;
};

export default AuthGuard;
